module.exports = __webpack_public_path__ + "img/TpTea.87c1d008.svg";